(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__uzProductCardSwatchesReady) return;
    window.__uzProductCardSwatchesReady = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('[data-product-card-root]');
      if (!card) return;

      card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
        button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
      });

      const image = card.querySelector('[data-product-card-image]');
      const mediaUrl = swatch.dataset.mediaUrl;
      if (!image || !mediaUrl) return;

      image.setAttribute('src', mediaUrl);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
